import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../auth/auth-state.service';
import { AuthService } from '../auth/auth.service';

export const twoFactorGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authState.requiresTwoFactor() && authService.hasPendingMfaSession()) {
    return true;
  }

  if (authService.hasPendingOtpSession()) {
    return true;
  }

  if (authState.isAuthenticated()) {
    return router.createUrlTree(['/app/smartfreight/rates']);
  }

  return router.createUrlTree(['/login']);
};
